import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Tagline from "@/components/Tagline";
import About from "@/components/About";
import Music from "@/components/Music";
import Press from "@/components/Press";
import Connect from "@/components/Connect";
import Footer from "@/components/Footer";
import useReveal from "@/hooks/useReveal";

export default function Landing() {
  useReveal();

  return (
    <main
      data-testid="landing-page"
      className="bg-ivory text-ink font-sans antialiased overflow-x-hidden"
    >
      <Nav />
      <Hero />
      <Tagline />
      <About />
      <Music />
      <Press />
      <Connect />
      <Footer />
    </main>
  );
}
